/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Company_Detail_Delete_Company_TitleInputs */

const en_admin_company_detail_delete_company_title = /** @type {(inputs: Admin_Company_Detail_Delete_Company_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete company`)
};

const de_admin_company_detail_delete_company_title = /** @type {(inputs: Admin_Company_Detail_Delete_Company_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unternehmen löschen`)
};

/**
* | output |
* | --- |
* | "Delete company" |
*
* @param {Admin_Company_Detail_Delete_Company_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_company_detail_delete_company_title = /** @type {((inputs?: Admin_Company_Detail_Delete_Company_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Company_Detail_Delete_Company_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_company_detail_delete_company_title(inputs)
	return en_admin_company_detail_delete_company_title(inputs)
});